export const META_LOADING = {
  loading: true
};

export const META_ERROR = {
  loadingError: true
}

export const META_ERROR_NOT_FOUND = {
  loadingError: true,
  notFound: true
}

export const META_LOADED = {
  hasInitialData: true
}

export const META_LOADED_LOADING = {
  hasInitialData: true,
  loading: true
};

export const META_LOADED_SINGLE = {
  hasInitialData: true,
  itemCount: 1
}

export function metaMissing(meta) {
  return meta === void 0;
}

export function metaLoading(meta) {
  return meta && meta.loading;
}

export function metaError(meta) {
  return meta && meta.loadingError;
}

export function metaUnauthorized(meta) {
  return meta && meta.loadingUnauthorized;
}

export function metaLoaded(meta) {
  return meta && meta.hasInitialData;
}

export function dataSaving(data) {
  return data && data.saving;
}

export function isMetaMissing(meta) {
  return Array.isArray(meta) ? meta.some(metaMissing) : metaMissing(meta);
}

export function isMetaLoading(meta) {
  return Array.isArray(meta) ? meta.some(metaLoading) : metaLoading(meta);
}

export function isMetaError(meta) {
  return Array.isArray(meta) ? meta.some(metaError) : metaError(meta);
}

export function isMetaUnauthorized(meta) {
  return Array.isArray(meta) ? meta.some(metaUnauthorized) : metaUnauthorized(meta);
}

export function isMetaLoaded(meta) {
  return Array.isArray(meta) ? meta.every(metaLoaded) : metaLoaded(meta);
}

export function isDataSaving(data) {
  return Array.isArray(data) ? data.some(dataSaving) : dataSaving(data);
}

export function getMetaItemCount(meta) {
  return meta ? meta.itemCount : void 0;
}

export function hasMetaItemCount(meta) {
  return getMetaItemCount(meta) > 0;
}

export function firstDataItem(data) {
  return data.firstItem();
}